import Keycloak, { KeycloakConfig } from 'keycloak-js';
import { api } from './api';

export let keycloak: Keycloak;

export const initKeycloak = (config: KeycloakConfig) => {
  keycloak = new Keycloak(config);
  return keycloak;
};

export const updateToken = async () => {
  try {
    const refreshed = await keycloak.updateToken(300);
    if (refreshed) {
      await handleAuthentication(true);
    } else {
      const url = await keycloak.createLoginUrl({ redirectUri: `${window.location.origin}/` });
      (window as any).location.href = url;
    }
  } catch (error: unknown) {
    const errorObj = error as { error?: string };
    const isRefreshTokenError = errorObj?.error === 'invalid_grant' ||
                                errorObj?.error === 'invalid_token' ||
                                errorObj?.error === 'invalid_request';

    if (isRefreshTokenError) {
      console.error('Token refresh failed with invalid token error, redirecting to login:', error);
    }
    const url = await keycloak.createLoginUrl({ redirectUri: `${window.location.origin}/` });
    (window as any).location.href = url;
  }
};

export const handleAuthentication = async (authenticated: boolean, skipTokenRefresh = false): Promise<boolean> => {
  if (!authenticated) {
    const search = new URLSearchParams(window.location.search);
    const action = search.get('action');

    const redirectUri = `${window.location.origin}/`;
    const url = action === 'register'
      ? await keycloak.createRegisterUrl({ redirectUri })
      : await keycloak.createLoginUrl({ redirectUri });
    (window as any).location.href = url;
    return false;
  }

  if (!skipTokenRefresh && keycloak.token && keycloak.isTokenExpired(30)) {
    try {
      await keycloak.updateToken(30);
    } catch (error: unknown) {
      const isTokenExpired = keycloak.isTokenExpired();
      const errorObj = error as { error?: string };
      const isRefreshTokenError = errorObj?.error === 'invalid_grant' ||
                                  errorObj?.error === 'invalid_token' ||
                                  errorObj?.error === 'invalid_request';

      if (isTokenExpired || isRefreshTokenError) {
        console.error('Token expired or invalid, redirecting to login:', error);
        const url = await keycloak.createLoginUrl({ redirectUri: `${window.location.origin}/` });
        (window as any).location.href = url;
        return false;
      }
      console.warn('Token refresh failed but token may still be valid:', error);
    }
  }

  if (keycloak.token) {
    localStorage.setItem('kc_token', keycloak.token);
  }

  if (keycloak.refreshToken) {
    localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
  }

  if (keycloak.token) {
    api.updateTokenInHeaders(keycloak.token);
  }

  return true;
};
